import React, { useState,useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import { useStore } from 'react-redux';
import { addCollegeCategory, getCollegeCategories, updateCollegeCategory } from './../../apis/services';
import { Modal } from 'react-bootstrap';
import { Checkbox } from "primereact/checkbox";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputSwitch } from "primereact/inputswitch";
import { setShowDeleteDialog } from '../../redux/reducer';
import DeleteModalContent from '../../commons/DeleteModalContent';

const CollegeCategories = () => {
    const { t } = useTranslation();
    const store = useStore();
    const [countries, setCategories] = useState([]);
    const [showAddCategoriesModal, setShowAddCategoriesModal] = useState(false);
    const [showEditCategoriesModal, setShowEditCategoriesModal] = useState({ show: false, item: '' });
    useEffect(() => {
        loadCategories();
    }, []);
    const loadCategories = async () => {
        try {
            const res = await getCollegeCategories();
            setCategories(res.data.college_categories);
        } catch (error) {
            console.log(error);
        }
    }
    return (
        <div>
            <div className="glass-card p-3">
                <div className="d-flex jcsb">
                    <div className='mt-2 mb-2'>
                        <h4>{t('manage_college_categories')}</h4>
                    </div>
                    <div className='p-2 d-flex'>
                        <Button className='p-btn mx-1'
                            onClick={() => {
                                setShowAddCategoriesModal(true);
                            }}
                        > {t('add_category')}</Button>
                    </div>
                </div>
                <Modal
                    show={showAddCategoriesModal}
                >
                    <div className='p-4'>
                        <AddCategories
                            submit={() => {
                                setShowAddCategoriesModal(false);
                                loadCategories();
                            }}
                            cancel={() => {
                                setShowAddCategoriesModal(false);
                            }}
                        />
                    </div>
                </Modal>
                <Modal
                    show={showEditCategoriesModal.show}
                >
                    <div className='p-4'>
                        <EditCategories
                            submit={() => {
                                setShowEditCategoriesModal({ show: false, item: '' });
                                loadCategories();
                            }}
                            cancel={() => {
                                setShowEditCategoriesModal({ show: false, item: '' });
                            }}
                            item={showEditCategoriesModal.item}
                        />
                    </div>
                </Modal>
                {

                }
                <DeleteModalContent
                    reload={() => {
                        loadCategories();
                    }}
                />
                <div className="data-table mt-2">
                    <DataTable
                        value={countries}
                        paginator
                        rows={10}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        rowsPerPageOptions={[10, 25, 50]}
                        dataKey="id"
                        selectionMode="checkbox"
                        filterDisplay="menu"
                        emptyMessage={t('data_not_available')}
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    >
                       
                        <Column
                            field="category_name"
                            header={t('name')}
                            sortable
                        />
                      
                      
                        <Column
                            header={t('status')}
                            sortField='status'
                            sortable
                            body={(row) => {
                                return (
                                    <InputSwitch checked={row.status === 1 ? true : false} />
                                )
                            }}
                        />
                        <Column
                            header={t('actions')}
                            body={(row) => {
                                return (
                                    <div className='d-flex'>
                                        <Button
                                            onClick={(e) => {
                                                setShowEditCategoriesModal({ show: true, item: row });
                                            }}
                                            className='icon-btn mx-1' severity='primary' id="edit-btn">
                                            <span className="material-symbols-outlined">
                                                edit
                                            </span>
                                        </Button>
                                        <Button
                                            onClick={() => {
                                                store.dispatch(setShowDeleteDialog({ show: true, url: '/collge/categories/delete/' + row.id }))
                                            }}
                                            className='icon-btn mx-1' severity='danger' id="edit-btn">
                                            <span className="material-symbols-outlined">
                                                delete
                                            </span>
                                        </Button>
                                    </div>
                                )
                            }}
                        />
                    </DataTable>
                </div>
            </div>
        </div>
    );

}

const AddCategories = (props) => {
    const { t } = useTranslation();
    const [categoryTitle, setCategoryTitle] = useState();
    const [status, setStatus] = useState(true);
    const handleAddCategories = async () => {
        try {
            let data = {
                categoryTitle:categoryTitle,
                status:status,

            }
            await addCollegeCategory(data);
            props.submit();
        } catch (error) {
            console.log(error);
        }
    }
    return (
        <form action=""
            onSubmit={(e) => {
                e.preventDefault();
                handleAddCategories();
            }}
        >
            <div className="row">
                <div className="col-12">
                    <div className="d-flex jcsb align-items-center">
                        <h5 className='mt-2 mb-3 opacity'>{t('add_category')}</h5>
                        <Button raised className='icon-btn' severity='secondary' type='button'
                            onClick={() => {
                                props.cancel();
                            }}
                        >
                            <span className="material-symbols-outlined">
                                cancel
                            </span>
                        </Button>
                    </div>
                </div>
                <div className="col-12 mb-2">
                    <div className="form-group">
                        <label htmlFor="categoryTitle" className='required mb-1' >{t('name')}</label>
                        <input type="text" id="categoryTitle" className='form-control' required
                            value={categoryTitle}
                            onChange={(e) => { setCategoryTitle(e.target.value) }}
                        />
                    </div>
                </div>

                
               
                <div className="col-md-12 mt-2">
                    <div className="d-flex">
                        <div className="flex align-items-center">
                            <Checkbox inputId="status" name="status" checked={status} className=''
                                onChange={() => {
                                    setStatus(!status);
                                }}
                            />
                            <label htmlFor="status" className="ml-2 mx-2">{t('enable_for_use')}</label>
                        </div>
                    </div>
                </div>
                <div className="col-12 mt-3">
                    <Button type='submit' className='p-btn'>{t('save')}</Button>
                </div>
            </div>
        </form>
    );
}
const EditCategories = (props) => {
    const { t } = useTranslation();
    const item = props.item;
    const [categoryTitle, setCategoryTitle] = useState(item.category_name);

    const [status, setStatus] = useState(item.status === 1 ? true : false);

    const handleEditCategories = async () => {
        try {
            let data = {
                id:item.id,
                categoryTitle:categoryTitle,
                status:status,

            }
            await updateCollegeCategory(data);
            props.submit();
        } catch (error) {
            console.log(error);
        }
    }
    return (
        <form action=""
            onSubmit={(e) => {
                e.preventDefault();
                handleEditCategories();
            }}
        >
            <div className="row">
                <div className="col-12">
                    <div className="d-flex jcsb align-items-center">
                        <h5 className='mt-2 mb-3 opacity'>{t('edit_category')}</h5>
                        <Button raised className='icon-btn' severity='secondary' type='button'
                            onClick={() => {
                                props.cancel();
                            }}
                        >
                            <span className="material-symbols-outlined">
                                cancel
                            </span>
                        </Button>
                    </div>
                </div>
                <div className="col-12 mb-2">
                    <div className="form-group">
                        <label htmlFor="categoryTitle" className='required mb-1' >{t('name')}</label>
                        <input type="text" id="categoryTitle" className='form-control' required
                            value={categoryTitle}
                            onChange={(e) => { setCategoryTitle(e.target.value) }}
                        />
                    </div>
                </div>
              
             
                <div className="col-md-12 mt-2">
                    <div className="d-flex">
                        <div className="flex align-items-center">
                            <Checkbox inputId="status" name="status" checked={status} className=''
                                onChange={() => {
                                    setStatus(!status);
                                }}
                            />
                            <label htmlFor="status" className="ml-2 mx-2">{t('enable_for_use')}</label>
                        </div>
                    </div>
                </div>
                <div className="col-12 mt-3">
                    <Button type='submit' className='p-btn'>{t('update')}</Button>
                </div>
            </div>
        </form>
    );
}
export default CollegeCategories;